import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RequiredActionComponent } from './required-action.component';
import { MissingAcceptedComponent } from './documentation/missing-accepted.component';
import { UserLoggedInGuard } from '../guards/user-logged-in.guard';
import { UserLoginRoleSelectionComponent } from './users/user-login-role-selection/user-login-role-selection.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
	{
		path: 'required-action',
		component: RequiredActionComponent,
		children: [
			{ path: 'documentation/acceptance', component: MissingAcceptedComponent, canActivate: [UserLoggedInGuard] },
			{ path: 'users/roleSelection', component: UserLoginRoleSelectionComponent, canActivate: [AuthGuard] },
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class RequiredActionRoutingModule {}
